import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M18.984 16.674a.75.75 0 0 1 .75.75 6.06 6.06 0 0 1-6.062 6.062.75.75 0 1 1 0-1.5 4.563 4.563 0 0 0 4.562-4.562.75.75 0 0 1 .75-.75m-2.386.127a.75.75 0 0 1 .75.75 3.55 3.55 0 0 1-3.548 3.548.75.75 0 1 1 0-1.5 2.05 2.05 0 0 0 2.048-2.048.75.75 0 0 1 .75-.75"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.932 2.085c1.835 0 3.307 1.506 3.307 3.341v2.947l.632.327a.75.75 0 0 1-.632 1.354v6.786c0 1.12-.899 2.045-2.028 2.045H7.59a2.037 2.037 0 0 1-2.028-2.045v-6.785a.75.75 0 0 1-.648-1.345l.648-.354v-2.93c0-1.835 1.472-3.341 3.307-3.341zm1.807 12.95a9.8 9.8 0 0 1-3.312.614c-1.144.017-2.312-.157-3.365-.546v1.737c0 .31.246.545.528.545h5.62a.536.536 0 0 0 .528-.545zm0-5.658c-2.093-.736-4.588-.778-6.677-.029v4.13c.958.462 2.137.69 3.343.672s2.382-.281 3.334-.746zm-4.87-5.791c-.989 0-1.807.815-1.807 1.84V7.77c2.145-.644 4.555-.602 6.677.032V5.426c0-1.025-.818-1.84-1.807-1.84z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const BlindSpotMonitorIcon = ForwardRef;